import React from "react";
import { Component } from "react";
// import { Switch } from "react-router-dom";
// import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
// import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, chooseFontColor, translate } from "../../utils/useful";
// import LoaderButton from "../LoaderButton";
import FixedView from "../FixedView";
import { FormBuilderObjects, TypeToInputType } from "../../variables/formBuilderData";
import SidebarView from "../SidebarView";
import importedIcons from "./icons";
import FormViewer from "../FormViewer";
import ButtonAnimated from "../buttons/ButtonAnimated";
import StagesManager from "../StagesManager";
import ParamsStageList from "./ParamsStageList";
// import { nanoid } from "nanoid";
// import React, { useRef, useState } from "react";

export default class TextComponentFloatConfig extends Component {
  state = {

    fontsize: [
      // { type: 8 },
      // { type: 9 },
      // { type: 10 },
      // { type: 11 },
      { type: 12 },
      { type: 13 },
      { type: 14 },
      { type: 15 },
      { type: 16 },
      { type: 17 },
      { type: 18 },
      { type: 20 },
      { type: 24 },
      { type: 30 },
      { type: 36 },
      { type: 48 },
      // { type: 60 },
      // { type: 72 },
      // { type: 96 },
    ],

    fontWeights: [
      { lable: '{{lang}}Light', value: 300 },
      { lable: '{{lang}}Normal', value: null },
      { lable: '{{lang}}Semibold', value: 500 },
      { lable: '{{lang}}Bold', value: 600 },
      { lable: '{{lang}}Bolder', value: 700 },
      { lable: '{{lang}}Extra Bold', value: 800 },
    ],
    actionHeader: [
      { key: 'type', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'view', value: 'view' }, { title: 'open window', value: 'openWindow' }], label: 'action', placeholder: 'Choose...', required: true } },
      {
        key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}pages', type: 'api', address: 'getFrames', filter: { type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}pages', required: false }, showMain: false,
        dependencies: [{
          refKey: 'type',
          targetKey: 'page',
          conditions: {
            root: {
              id: 'root',
              action: 'or',
              conditions: {
                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } },
                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
              }
            },
          },
          show: true,
          init: true,
        }],
      }

    ],

    colors: [
      '#F44336',
      '#FFEBEE',
      '#FFCDD2',
      '#EF9A9A',
      '#E57373',
      '#EF5350',
      '#F44336',
      '#E53935',
      '#D32F2F',
      '#C62828',
      '#B71C1C',
      '#FF8A80',
      '#FF5252',
      '#FF1744',
      '#D50000',
      '#E91E63',
      '#FCE4EC',
      '#F8BBD0',
      '#F48FB1',
      '#F06292',
      '#EC407A',
      '#E91E63',
      '#D81B60',
      '#C2185B',
      '#AD1457',
      '#880E4F',
      '#FF80AB',
      '#FF4081',
      '#F50057',
      '#C51162',
      '#9C27B0',
      '#F3E5F5',
      '#E1BEE7',
      '#CE93D8',
      '#BA68C8',
      '#AB47BC',
      '#9C27B0',
      '#8E24AA',
      '#7B1FA2',
      '#6A1B9A',
      '#4A148C',
      '#EA80FC',
      '#E040FB',
      '#D500F9',
      '#AA00FF',
      '#673AB7',
      '#EDE7F6',
      '#D1C4E9',
      '#B39DDB',
      '#9575CD',
      '#7E57C2',
      '#673AB7',
      '#5E35B1',
      '#512DA8',
      '#4527A0',
      '#311B92',
      '#B388FF',
      '#7C4DFF',
      '#651FFF',
      '#6200EA',
      '#3F51B5',
      '#E8EAF6',
      '#C5CAE9',
      '#9FA8DA',
      '#7986CB',
      '#5C6BC0',
      '#3F51B5',
      '#3949AB',
      '#303F9F',
      '#283593',
      '#1A237E',
      '#8C9EFF',
      '#536DFE',
      '#3D5AFE',
      '#304FFE',
      '#2196F3',
      '#E3F2FD',
      '#BBDEFB',
      '#90CAF9',
      '#64B5F6',
      '#42A5F5',
      '#2196F3',
      '#1E88E5',
      '#1976D2',
      '#1565C0',
      '#0D47A1',
      '#82B1FF',
      '#448AFF',
      '#2979FF',
      '#2962FF',
      '#03A9F4',
      '#E1F5FE',
      '#B3E5FC',
      '#81D4FA',
      '#4FC3F7',
      '#29B6F6',
      '#03A9F4',
      '#039BE5',
      '#0288D1',
      '#0277BD',
      '#01579B',
      '#80D8FF',
      '#40C4FF',
      '#00B0FF',
      '#0091EA',
      '#00BCD4',
      '#E0F7FA',
      '#B2EBF2',
      '#80DEEA',
      '#4DD0E1',
      '#26C6DA',
      '#00BCD4',
      '#00ACC1',
      '#0097A7',
      '#00838F',
      '#006064',
      '#84FFFF',
      '#18FFFF',
      '#00E5FF',
      '#00B8D4',
      '#009688',
      '#E0F2F1',
      '#B2DFDB',
      '#80CBC4',
      '#4DB6AC',
      '#26A69A',
      '#009688',
      '#00897B',
      '#00796B',
      '#00695C',
      '#004D40',
      '#A7FFEB',
      '#64FFDA',
      '#1DE9B6',
      '#00BFA5',
      '#4CAF50',
      '#E8F5E9',
      '#C8E6C9',
      '#A5D6A7',
      '#81C784',
      '#66BB6A',
      '#4CAF50',
      '#43A047',
      '#388E3C',
      '#2E7D32',
      '#1B5E20',
      '#B9F6CA',
      '#69F0AE',
      '#00E676',
      '#00C853',
      '#8BC34A',
      '#F1F8E9',
      '#DCEDC8',
      '#C5E1A5',
      '#AED581',
      '#9CCC65',
      '#8BC34A',
      '#7CB342',
      '#689F38',
      '#558B2F',
      '#33691E',
      '#CCFF90',
      '#B2FF59',
      '#76FF03',
      '#64DD17',
      '#CDDC39',
      '#F9FBE7',
      '#F0F4C3',
      '#E6EE9C',
      '#DCE775',
      '#D4E157',
      '#CDDC39',
      '#C0CA33',
      '#AFB42B',
      '#9E9D24',
      '#827717',
      '#F4FF81',
      '#EEFF41',
      '#C6FF00',
      '#AEEA00',
      '#FFEB3B',
      '#FFFDE7',
      '#FFF9C4',
      '#FFF59D',
      '#FFF176',
      '#FFEE58',
      '#FFEB3B',
      '#FDD835',
      '#FBC02D',
      '#F9A825',
      '#F57F17',
      '#FFFF8D',
      '#FFFF00',
      '#FFEA00',
      '#FFD600',
      '#FFC107',
      '#FFF8E1',
      '#FFECB3',
      '#FFE082',
      '#FFD54F',
      '#FFCA28',
      '#FFC107',
      '#FFB300',
      '#FFA000',
      '#FF8F00',
      '#FF6F00',
      '#FFE57F',
      '#FFD740',
      '#FFC400',
      '#FFAB00',
      '#FF9800',
      '#FFF3E0',
      '#FFE0B2',
      '#FFCC80',
      '#FFB74D',
      '#FFA726',
      '#FF9800',
      '#FB8C00',
      '#F57C00',
      '#EF6C00',
      '#E65100',
      '#FFD180',
      '#FFAB40',
      '#FF9100',
      '#FF6D00',
      '#FF5722',
      '#FBE9E7',
      '#FFCCBC',
      '#FFAB91',
      '#FF8A65',
      '#FF7043',
      '#FF5722',
      '#F4511E',
      '#E64A19',
      '#D84315',
      '#BF360C',
      '#FF9E80',
      '#FF6E40',
      '#FF3D00',
      '#DD2C00',
      '#795548',
      '#EFEBE9',
      '#D7CCC8',
      '#BCAAA4',
      '#A1887F',
      '#8D6E63',
      '#795548',
      '#6D4C41',
      '#5D4037',
      '#4E342E',
      '#3E2723',
      '#9E9E9E',
      '#FAFAFA',
      '#F5F5F5',
      '#EEEEEE',
      '#E0E0E0',
      '#BDBDBD',
      '#9E9E9E',
      '#757575',
      '#616161',
      '#424242',
      '#212121',
      '#607D8B',
      '#ECEFF1',
      '#CFD8DC',
      '#B0BEC5',
      '#90A4AE',
      '#78909C',
      '#607D8B',
      '#546E7A',
      '#455A64',
      '#37474F',
      '#263238',
      '#000000',
      '#FFFFFF',
    ],
  };

  componentDidMount() {
    // console.log('TextComponentFloatConfigprops', this.props)
    // console.log('TextComponentFloatConfigstate', this.state)
    setTimeout(() => {
      this.setState({ show: true })
    }, 10);
  }

  setData = (key, value, myRef) => {
    if (myRef) {
      myRef.hideView()
    }

    this.props.setData(this.props.header?.key, key, value)
  }


  makeInvisible = () => {
    this.props.makeInvisible(this.props.header?.key, this.props.index)
  }

  changeSelectedTextEffects = (key, value, myRef) => {
    // "colorpicker"
    if (myRef) {
      myRef.hideView()
    }
    this.props.changeSelectedTextEffects({ effectType: key, value: value }, this.props.editorId)

  }

  liveChange = (data, init, key, value, extra) => {

    this.props.setElementSettings(this.props.index, "information.action." + key, value)

  }

  // this.props.setElementSettings(this.props.index, "information." + key, value)

  insertText = (text) => {
    // console.log('insertText', text)
    this.parametersView.hideView()
    this.props.insertText(text.replace('{{lang}}', ''))
  }


  showParamsChildren = (item) => {

    this.setState({ currentParentParam: item })
    if (this.paramsStagesManager) {
      this.paramsStagesManager.changeStage("childrenList")
    }

  }

  goToParentParams = () => {

    this.setState({ currentParentParam: null })
    if (this.paramsStagesManager) {
      this.paramsStagesManager.changeStage("mainList")
    }

  }

  backToChildrenParams = () => {

    this.setState({ tempCurrentParamObject: null })
    if (this.paramsStagesManager) {
      this.paramsStagesManager.changeStage("childrenList")
    }

  }

  addParamToText = (item, field) => {

    // console.log(item, field)
    this.insertText("{{" + checkTranslation(item.label) + ' - ' + checkTranslation(field.information?.label ?? field.name) + "}}")

  }

  addParamObjectToText = (item, field) => {

    let tempCurrentParamObject = this.state.tempCurrentParamObject

    // console.log(item, field)
    if (tempCurrentParamObject) {
      this.insertText("{{" + checkTranslation(item.label) + ' - ' + checkTranslation(tempCurrentParamObject.information?.label ?? tempCurrentParamObject.name) + '.' + checkTranslation(field.information?.label ?? field.name) + "}}")
    }
  }


  setParamAsObject = (item) => {

    this.setState({ tempCurrentParamObject: item }, () => {

      if (this.paramsStagesManager) {
        this.paramsStagesManager.changeStage('objectList')
      }

    })
  }



  showParams = () => {

    return (

      <div className=' w-100' >

        {(this.props.params == null || this.props.params?.length == 0) && (
          <div className="text-center py-2">
            <p className="text-small">{translate("Found nothing")}</p>
          </div>
        )}

        {Array.isArray(this.props.params) && (
          <div className="pb-3">
            {this.props.params?.map((item, index) => {
              return (
                <div className=" pt-2 pb-2 w-100 " key={item.value} style={{ borderBottom: '1px solid #eee' }}>
                  <div className="px-1">
                    <p draggable={false} className=" text-bold text-small">{translate(item.label)}</p>
                  </div>

                  {item.fields?.map((field, index) => {
                    if (field.type != 'ImageInput' && field.type != 'FileInput' && field.type != 'VideoInput')
                      return (

                        <button className=" flexcb w-100 text-smaller text-start mt-2" style={{ cursor: 'pointer', }} onClick={() => { this.insertText("{{" + item.label + ' - ' + field.information?.label + "}}") }}>
                          <div className='flexc'>
                            <img draggable={false} src={FormBuilderObjects[field.type]?.icon} className='br-20 mrd-3' height={20} style={{ filter: 'grayscale(0%)' }} alt="" />
                            <p draggable={false} className=" text-semibold text-smaller">{translate(field.information?.label)}</p>
                          </div>

                          <img src='/assets/icons/drag-and-drop.svg' height={15} className='flexcc opacity-2 ' alt="" />

                        </button>
                      )
                  })}

                </div>
              )
            })}
          </div>
        )}

        {(this.props.params && typeof this.props.params == 'object') && (
          <div>
            <StagesManager ref={e => this.paramsStagesManager = e} fast={true}>

              <div stage={0} stageName={'mainList'}>

                {/* <div className="bb-gray w-100 px-1 py-2 flexc mb-2" style={{ position: 'sticky', top: 0, background: '#fff' }}>
                  <p className="text-small text-semibold">{translate("Params")}</p>
                </div> */}

                {this.props.params && Object.values(this.props.params)?.map((item, index) => {
                  return (
                    <button className="p-1 px-1  w-100 text-start" onClick={() => this.showParamsChildren(item)}>
                      <div key={index} className="flexcb " >
                        <div className="flexc">
                          <p className="text-small text-semibold">{checkTranslation(item?.label)}</p>
                        </div>
                        <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />

                      </div>

                      <p className="text-smaller color-gray-2">{item.list?.length} items</p>

                    </button>
                  )
                })}

              </div>


              <div stage={1} stageName={'childrenList'}>

                <div className="scroll-no-scrollbar" style={{ maxHeight: '200px' }}>
                  <div className="bb-gray w-100 px-1 py-2 flexc mb-2" style={{ position: 'sticky', zIndex: 1, top: 0, background: '#fff' }}>
                    <button className="flexcc" onClick={() => { this.goToParentParams() }}>
                      <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} alt="" />
                    </button>
                    <p className="text-small text-semibold">{(checkTranslation(this.props.params[this.state.currentParentParam?.key]?.label))}</p>
                  </div>
                  {this.props.params && this.props.params[this.state.currentParentParam?.key]?.list?.map((element) => {

                    let name = element.name ?? element?.information?.label
                    let key = element._id ?? element.key
                    let type = (element.dataType ?? element.type)?.toLowerCase()
                    let isObject = false
                    if (type) {
                      type = TypeToInputType[type] ?? (element.dataType ?? element.type)
                    }

                    if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput') {
                      isObject = true
                    }

                    return (

                      <button key={key} className="flexcb p-1 px-1 mb-1 grayscale-filter  w-100 text-start" onClick={() => isObject ? this.setParamAsObject(element) : this.addParamToText(this.state.currentParentParam, element)}>
                        <div className="flexc">
                          <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                            <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" />
                          </div>
                          <p className="text-small text-semibold">{checkTranslation(name)}</p>
                        </div>
                        {isObject && (
                          <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                        )}
                      </button>
                    )
                  })}
                </div>

              </div>



              <div stage={1} stageName='objectList' >

                <div className="scroll-no-scrollbar" style={{ maxHeight: '200px' }}>
                  <div className="bb-gray w-100 px-2 py-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                    <button className="flexcc" onClick={() => { this.backToChildrenParams() }}>
                      <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} />
                    </button>
                    <p className="text-small text-semibold">{(checkTranslation(this.state.tempCurrentParamObject?.name))}</p>
                  </div>
                  {this.state.tempCurrentParamObject?.structure?.map((element) => {
                    let name = element.name ?? element?.information?.label
                    let key = element._id ?? element.key
                    key = this.state.tempCurrentParamObject?.key + '.' + key
                    let type = (element.dataType ?? element.type)?.toLowerCase()
                    let isObject = false
                    if (type) {
                      type = TypeToInputType[type] ?? (element.dataType ?? element.type)
                    }
                    if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput') {
                      isObject = true
                    }

                    return (

                      <button key={key} className="flexcb p-1 px-2 mb-1 grayscale-filter  w-100" onClick={() => isObject ? this.setParamAsObject(element) : this.addParamObjectToText(this.state.currentParentParam, element)}>
                        <div className="flexc">
                          <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                            <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" alt="" />
                          </div>
                          <p className="text-small text-semibold">{checkTranslation(name)}</p>
                        </div>
                        {isObject && (
                          <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                        )}
                      </button>
                    )
                  })}
                </div>

              </div>


            </StagesManager>
          </div>
        )}

      </div>

    )
  }



  render() {

    let section = {}
    return (


      <>
        <div className={'h-100   flexc pb-2 pt-1  ' + (this.props.style?.position ? 'w-100' : '')} style={{ position: this.props.style?.position ?? 'absolute', bottom: this.props.style?.bottom ?? -40, top: this.props.style?.top ?? 'auto', left: 0, zIndex: 1, alignItems: 'flex-end', borderBottom: '1px solid #eee', backgroundColor: '#fff' }} onClick={e => e.stopPropagation()}>
          <div className={'flexc w-100 px-1'} style={{ background: this.props.style?.background ?? null, boxShadow: this.props.style?.boxShadow ?? null }}>
            {/* {!this.props.style?.position && (
              <img onMouseDown={(e) => this.props.startMove(e)} draggable={false} {...this.props.provided?.dragHandleProps} src='/assets/icons/drag-and-drop.svg' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />
            )} */}
            <img ref={(el) => (this.fontSizeBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/font-size.png' height={18} className={" px-1 " + (this.props.dontInvert ? '' : 'invert')} />
            <img ref={(el) => (this.textColorBut = el)} onClick={() => this.textColorView.showView()} src='/assets/icons/builder/paint-bucket.png' height={18} className={" px-1 " + (this.props.dontInvert ? '' : 'invert')} />
            <img ref={(el) => (this.textAlignBut = el)} onClick={() => this.fontSizeView.showView()} src='/assets/icons/builder/align-left.png' height={18} className={" px-1 " + (this.props.dontInvert ? '' : 'invert')} />
            <img ref={(el) => (this.textWeightBut = el)} onClick={() => this.textWeightView.showView()} src='/assets/icons/builder/bold.png' height={18} className={" px-1 " + (this.props.dontInvert ? '' : 'invert')} />
            {this.props.header.type == 'ButtonInput' ?
              <img ref={(el) => (this.actionsBut = el)} onClick={() => this.actionstView.open()} src='/assets/icons/builder/function.svg' height={18} className={" px-1 " + (this.props.dontInvert ? '' : 'invert')} />
              : <div></div>
            }
            <button ref={(el) => (this.parametersBut = el)} onClick={() => this.parametersView.showView()}>
              <p className={"text-small text-semibold  " + (this.props.dontInvert ? '' : 'invert')}>{translate("Params")}</p>
            </button>


          </div>
        </div>

        {this.state.show && (
          <>


            <FixedView zIndex={10} ref={(el) => (this.fontSizeView = el)} nodeRef={this.fontSizeBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={40} width={100}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">
                    {this.state.fontsize.map((prop, index) => {
                      return (
                        <div className="bb-gray" key={index}>
                          {/* <button onClick={() => this.setData('fontSize', prop.type, this.fontSizeView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray"> */}
                          <button onClick={() => this.changeSelectedTextEffects('fontSize', prop.type + 'px', this.fontSizeView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray">
                            <p className="text-left">  {checkTranslation(prop.type)}   </p>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </FixedView>



            <FixedView zIndex={10} ref={(el) => (this.textColorView = el)} nodeRef={this.textColorBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={300} width={300}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >

                  <button className="flexc mb-1 px-1" onClick={() => this.setData('textColor', null, this.textColorView)} >
                    <img src="/assets/icons/builder/color-palette.png" height={12} />
                    <p className="text-smaller px-1 text-semibold">{translate("Reset Color")}</p>
                  </button>

                  <div className="flexc  flex-wrap">
                    {this.state.colors.map((prop, index) => {
                      let color = prop
                      return (
                        <div className="color-picker-hover p-1 br-4 flexcc" key={index}>
                          <button onClick={() => this.changeSelectedTextEffects('color', color, this.textColorView)} className="flexcc" style={{ height: 22, width: 22 }}>
                            <div className="br-20" style={{ background: color, height: 20, width: 20, border: chooseFontColor(color) != '#fff' ? '1px solid #eee' : '1px solid transparent' }}>

                            </div>
                          </button>
                        </div>
                      );
                    })}

                  </div>

                  <div className="w-100 mt-1 px-1 py-1" style={{ borderTop: '1px solid #eee' }}>
                    <button className="pt-2 pb-1 " >
                      <p className="text-smaller text-semibold">{translate("Conditional Formatting")}</p>
                    </button>
                  </div>
                </div>
              </div>
            </FixedView>




            <FixedView zIndex={10} ref={(el) => (this.textWeightView = el)} nodeRef={this.textWeightBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={120} width={120}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2 w-100" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">
                    {this.state.fontWeights.map((prop, index) => {
                      return (
                        <div className="bb-gray w-100" key={index}>
                          {/* <button onClick={() => this.setData('fontWeight', prop.value, this.textWeightView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray"> */}
                          <button onClick={() => this.changeSelectedTextEffects('fontWeight', prop.value, this.textWeightView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray">
                            <p className="text-left">  {checkTranslation(prop.lable)}</p>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </FixedView>




            <SidebarView width={this.props.width} zIndex={999} ref={el => this.actionstView = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '35%', lg: "35%", xl: "25%" }}>
              <div className="scroll-no-scrollbar h-100 white-bg" style={{ backgroundColor: '#fff' }} onClick={(e) => e.stopPropagation()}>
                <div className='px-2 py-2 w-100 flexcb'>
                  <p>{translate("Actions List")}</p>
                </div>
                <FormViewer ref={el => this.form = el} initData={this.props.element?.information} liveChange={this.liveChange} headers={this.state?.actionHeader} formClass="modern" inputClass={'modern-input'} />
              </div>
            </SidebarView>
            {/* <FixedView zIndex={10} ref={(el) => (this.actionstView = el)} nodeRef={this.actionsBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={120} width={120}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2 w-100" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">
                    {this.state.fontWeights.map((prop, index) => {
                      return (
                        <div className="bb-gray w-100">
                          <button onClick={() => this.changeSelectedTextEffects('fontWeight', prop.value, this.textWeightView)} className="px-1 py-1 my-1 br-5 w-100 hover-gray">
                            <p className="text-left">  {checkTranslation(prop.lable)}</p>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </FixedView> */}




            <FixedView zIndex={10} ref={(el) => (this.parametersView = el)} nodeRef={this.parametersBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={200} width={200}   >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2 w-100" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column ">

                    {/* <div className="w-100 flexc px-1">
                      <p className="text-smaller text-bold">{translate("Variables")}</p>
                    </div> */}


                    {/* <ParamsStageList params={this.props.params} data={this.props.prop.target} changeValue={this.changeTargetValue} extra={{ id: this.props.prop.id }} optionsList={this.props.optionsList} asVariable={true} /> */}

                    {this.showParams()}



                  </div>
                </div>
              </div>
            </FixedView>




          </>
        )}
      </>

    );
  }
}

// export default TextComponentFloatConfig;
